import {isPlatformBrowser, isPlatformServer} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LegacyServicesService {
  private _L: any;

  public constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this._init();
  }

  private _init(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._requireLegacyResources();
    }
  }

  private _requireLegacyResources(): void {
    this._L = require('leaflet');
    require('leaflet-draw');
    require('leaflet.markercluster');
    require('leaflet-freehandshapes');
  }

  private _safeGet(getCallback: () => any): any {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    return getCallback();
  }

  public getL(): any {
    return this._safeGet(() => this._L);
  }
}
